var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BlueExternalLink } from '@hn-ui/links';
import { styled } from 'styled-components';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1rq3dr1" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  gap: 16px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  gap: 16px;\n"])));
var Title = styled.h2.withConfig({ displayName: "Title", componentId: "sc-gr4d1n" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  margin: 0;\n"], ["\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  margin: 0;\n"])));
var Text = styled.p.withConfig({ displayName: "Text", componentId: "sc-1rij5au" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0;\n"], ["\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0;\n"])));
var ReportDescription = function (_a) {
    var rest = __rest(_a, []);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(Title, { children: "Parent Report" }, void 0), _jsxs(Text, { children: ["These reports are designed to share your students' progress with parents. Explore their entire year on Happy Numbers, including curriculum progress, math growth, and readiness for the next grade level.", ' ', _jsx(BlueExternalLink, __assign({ href: 'https://help.happynumbers.com/en/articles/6222102-individual-student-report-for-parents' }, { children: "Learn more" }), void 0)] }, void 0)] }), void 0));
};
export { ReportDescription };
var templateObject_1, templateObject_2, templateObject_3;
